import { useState, useContext } from "react"
import { SectionTitle } from "../global/SectionTitle"
import { Countdown } from "./Countdown"
import { Product } from "../global/Product" 
import { ScrollArrows } from "./ScrollArrows"
import { CustomButton } from "../global/CustomButton"
import { ProductsContext } from "../../contexts/ProductsContext"
import "./salesSection.css"

export function SalesSection(){
    const [scrollIndex, setScrollIndex] = useState(0)
    const scrollLimit = 1

    const countdownDate = new Date("October 8 2025 00:00:00").getTime()

    function scrollProducts(i) {
        if (scrollIndex + i >= 0 && scrollIndex + i <= scrollLimit) {
            setScrollIndex(scrollIndex + i)
        }
    }

    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext

    return (
        <div className="sales-section">
            <SectionTitle title="Today's" />

            <div className="d-flex flash-sales my-3 lg-row">
                <p className="my-auto section-title">Flash Sales</p>
                <Countdown countdownDate={countdownDate} />
                <div className="ms-auto scroll-arrows lg-on">
                    <ScrollArrows
                        scrollSection={scrollProducts}
                        scrollIndex={scrollIndex}
                        scrollLimit={scrollLimit}
                    />
                </div>
            </div>

            <div className="sales-container">
                <div className="sales-slide d-flex justify-content-between" style={{
                    left: (-100 * scrollIndex) + "%"
                }}>
                    
                    {
                        products && products.filter(a => a.discount).map((e, i) => (
                            <Product
                                key={i}
                                id={e._id}
                                name={e.title}
                                image={e.image}
                                regularPrice={e.regularPrice}
                                salePrice={e.salePrice}
                                discount={e.discount}
                                rating={e.rating.rate}
                                reviews={e.rating.reviews}
                            />
                        ))
                    }

                </div>
            </div>

            <div className="d-flex justify-content-center my-5">
                <CustomButton
                    btnLink={true}
                    path="/shop"
                    text="View All Products"
                    color="primary"
                />
            </div>

            <hr />
        </div>
    )
}